(function ($) {
  function wrapLinesInSpans(mark) {
    const text = mark.textContent;
    const words = text.split(" ");
    // Clear the mark element
    mark.innerHTML = "";
    // Temporarily add words to detect line breaks
    const tempSpans = [];
    words.forEach(function (word) {
      const span = document.createElement("span");
      span.textContent = word + " ";
      span.style.display = "inline";
      mark.appendChild(span);
      tempSpans.push(span);
    });
    // Group words by line
    const lines = [];
    let currentLine = [];
    let lastTop = null;
    tempSpans.forEach(function (span) {
      const rect = span.getBoundingClientRect();
      const currentTop = rect.top;
      if (lastTop !== null && currentTop > lastTop) {
        // New line detected
        lines.push(currentLine);
        currentLine = [span.textContent];
      } else {
        currentLine.push(span.textContent);
      }
      lastTop = currentTop;
    });
    // Don't forget the last line
    if (currentLine.length > 0) {
      lines.push(currentLine);
    }
    // Clear and rebuild with line spans
    mark.innerHTML = "";
    let delay = 0;
    lines.forEach(function (lineWords) {
      const lineText = lineWords.join("").trim();
      const lineSpan = document.createElement("span");
      lineSpan.textContent = lineText + " ";
      lineSpan.classList.add("highlight-line");
      // Set character count as data attribute or CSS variable
      const charCount = lineText.length;
      if (charCount <= 7) {
        lineSpan.classList.add("short");
      } else if (charCount <= 14) {
        lineSpan.classList.add("medium");
      } else if (charCount <= 21) {
        lineSpan.classList.add("long");
      } else {
        lineSpan.classList.add("xlong");
      }
      // Add staggered animation delay
      lineSpan.setAttribute("style", `--animation-delay: ${delay}ms;`);
      delay += 300; // Increase delay for next line
      mark.appendChild(lineSpan);
    });
  }

  /**
   * Compares text between initial and rollover states, highlighting differences.
   * Wraps changed or new words in .text-primary spans for visual emphasis.
   * If a rollover line has no corresponding initial line, the entire line is highlighted.
   *
   * @param {HTMLElement} rollover - The .marker-rollover container element
   */
  function compareAndHighlightDifferences(rollover) {
    const initialLines = rollover.querySelectorAll(".initial .highlight-line");
    const rolloverLines = rollover.querySelectorAll(
      ".rollover .highlight-line",
    );

    rolloverLines.forEach(function (rolloverLine, index) {
      const initialLine = initialLines[index];

      if (!initialLine) {
        // No corresponding initial line, entire line is new - wrap in .text-primary
        const content = rolloverLine.textContent;
        rolloverLine.innerHTML = "";
        const span = document.createElement("span");
        span.classList.add("text-primary");
        span.textContent = content;
        rolloverLine.appendChild(span);
      } else {
        const initialWords = initialLine.textContent.trim().split(/\s+/);
        const rolloverWords = rolloverLine.textContent.trim().split(/\s+/);

        // Clear the rollover line
        rolloverLine.innerHTML = "";

        // Compare word by word
        rolloverWords.forEach(function (word, wordIndex) {
          const initialWord = initialWords[wordIndex];

          if (word !== initialWord) {
            // Word is different, wrap in .text-primary
            const span = document.createElement("span");
            span.classList.add("text-primary");
            span.textContent = word + " ";
            rolloverLine.appendChild(span);
          } else {
            // Word is the same, just add as text
            rolloverLine.appendChild(document.createTextNode(word + " "));
          }
        });
      }
    });
  }
  function highLightText() {
    // Get all span.highlight elements
    const highlights = document.querySelectorAll("span.highlight");
    // Bail if there are no highlights
    if (highlights.length === 0) {
      return;
    }
    // Loop through each highlight element, change it to a mark tag
    highlights.forEach(function (highlight) {
      const mark = document.createElement("mark");
      // Wrap all the words in a single span initially
      const span = document.createElement("span");

      // Preserve existing classes to the mark
      highlight.classList.forEach(function (cls) {
        if (cls !== "highlight") {
          mark.classList.add(cls);
        }
      });

      span.textContent = highlight.textContent;
      mark.appendChild(span);
      highlight.parentNode.replaceChild(mark, highlight);
    });
  }

  function processHighlights() {
    const marks = document.querySelectorAll("mark");
    marks.forEach(function (mark) {
      wrapLinesInSpans(mark);
    });
  }

  function reinitializeMarks(rollover) {
    const marks = rollover.querySelectorAll("mark");

    marks.forEach(function (mark) {
      // Remove initialized class
      mark.classList.remove("initialized");
      // Re-process the mark
      wrapLinesInSpans(mark);
      // Re-observe to add initialized class when in viewport
      observer.observe(mark);
    });

    // Compare and highlight differences
    compareAndHighlightDifferences(rollover);
  }

  // Create intersection observer for adding 'initialized' class
  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const mark = entry.target;
          // Add initialized class when in viewport
          if (!mark.classList.contains("initialized")) {
            mark.classList.add("initialized");
            // Stop observing this element
            observer.unobserve(mark);
          }
        }
      });
    },
    {
      rootMargin: "-100px", // Element must be 100px inside viewport
      threshold: 0,
    },
  );

  // Create intersection observer for mobile auto-hover on .marker-rollover
  const rolloverObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const rollover = entry.target;

          // Only trigger on mobile (below 768px)
          if (
            window.innerWidth < 768 &&
            !rollover.classList.contains("animated")
          ) {
            setTimeout(function () {
              rollover.classList.add("animated");

              // Reinitialize the marks and compare
              reinitializeMarks(rollover);
            }, 1000);

            // Stop observing after animation triggered
            rolloverObserver.unobserve(rollover);
          }
        }
      });
    },
    {
      rootMargin: "-50px",
      threshold: 0.1,
    },
  );

  // Initialize on load
  document.addEventListener("DOMContentLoaded", function () {
    // Convert all highlights to marks
    highLightText();
    // Process all marks (add highlight-line spans, etc.)
    processHighlights();

    // Then observe all marks to add 'initialized' class when scrolled into view
    const marks = document.querySelectorAll("mark");
    marks.forEach(function (mark) {
      observer.observe(mark);
    });

    // Handle .marker-rollover hover reanimation
    const rollovers = document.querySelectorAll(".marker-rollover");
    rollovers.forEach(function (rollover) {
      // Desktop: reinitialize on hover
      rollover.addEventListener("mouseenter", function () {
        if (window.innerWidth >= 768) {
          console.log("Hover detected on desktop, reinitializing marks...");
          reinitializeMarks(rollover);
        }
      });

      // Mobile: observe for auto-animation
      if (window.innerWidth < 768) {
        rolloverObserver.observe(rollover);
      }
    });
  });

  // Re-process all marks on window resize with debounce
  jfDebounce("resize", processHighlights, 100);
})(jQuery);
